import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './PartnerSignup.css';

const PartnerSignup = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [newPartnerId, setNewPartnerId] = useState(null);
  const [form, setForm] = useState({
    name: '',
    phone: '',
    email: '',
    idType: 'Aadhar',
    idNumber: '',
    idFile: null,
    city: '',
    state: '',
    bankAcc: '',
    reBankAcc: '',
    ifsc: '',
    bankName: '',
    bankBranch: '',
    checkPhoto: null,
    acceptedTerms: false,
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : type === 'file' ? files[0] : value,
    }));
  };

  const validate = () => {
    const newErrors = {};
    if (!form.name) newErrors.name = 'Name is required';
    if (!/^\d{10}$/.test(form.phone)) newErrors.phone = 'Phone must be 10 digits';
    if (!/\S+@\S+\.\S+/.test(form.email)) newErrors.email = 'Email is invalid';
    if (!form.idNumber) newErrors.idNumber = `${form.idType} Number is required`;
    if (!form.idFile) newErrors.idFile = `Upload of ${form.idType} is required`;
    if (!form.city) newErrors.city = 'City is required';
    if (!form.state) newErrors.state = 'State is required';
    if (!form.bankAcc) newErrors.bankAcc = 'Bank account number is required';
    if (form.bankAcc !== form.reBankAcc) newErrors.reBankAcc = 'Account numbers do not match';
    if (!form.ifsc) newErrors.ifsc = 'IFSC Code is required';
    if (!form.bankName) newErrors.bankName = 'Bank Name is required';
    if (!form.bankBranch) newErrors.bankBranch = 'Branch Name is required';
    if (!form.checkPhoto) newErrors.checkPhoto = 'Upload cancelled cheque or passport photo';
    if (!form.acceptedTerms) newErrors.acceptedTerms = 'You must accept terms & conditions';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setLoading(true); // Start loading

    const formData = new FormData();
    Object.entries(form).forEach(([key, value]) => {
      formData.append(key, value);
    });

    try {
      const res = await fetch('https://abomed-backend-nodejs.vercel.app/partner/signup', {
        method: 'POST',
        body: formData,
      });

      const data = await res.json();

      if (res.ok && data.message === 'Partner signed up successfully' && data.partnerId) {
        setNewPartnerId(data.partnerId);
        setShowModal(true);
        setForm({
          name: '',
          phone: '',
          email: '',
          idType: 'Aadhar',
          idNumber: '',
          idFile: null,
          city: '',
          state: '',
          bankAcc: '',
          reBankAcc: '',
          ifsc: '',
          bankName: '',
          bankBranch: '',
          checkPhoto: null,
          acceptedTerms: false,
        });
        setErrors({});
      } else if (res.ok) {
        toast.success('Form submitted successfully!');
        setTimeout(() => navigate('/partner/login'), 1000);
      } else {
        toast.error(`Submission failed: ${data.message || 'Unknown error'}`);
      }
    } catch (err) {
      console.error('Submission error:', err);
      toast.error('Something went wrong during submission.');
    }

    setLoading(false); // End loading
  };


  return (
    <div className="signup-container">
      <ToastContainer/>
      <h2>Marketing Partner Registration</h2>
      <form onSubmit={handleSubmit}>
        {/* Personal Info */}
        <div className="section">
          <h3>Personal Information</h3>
          <div className="fields-grid">
            {/* ...existing code... */}
            <div className="form-group">
              <label>Name</label>
              <input type="text" name="name" value={form.name} onChange={handleChange} />
              {errors.name && <span className="error">{errors.name}</span>}
            </div>
            <div className="form-group">
              <label>Phone Number</label>
              <input type="text" name="phone" value={form.phone} onChange={handleChange} />
              {errors.phone && <span className="error">{errors.phone}</span>}
            </div>
            <div className="form-group">
              <label>Email</label>
              <input type="text" name="email" value={form.email} onChange={handleChange} />
              {errors.email && <span className="error">{errors.email}</span>}
            </div>
            <div className="form-group">
              <label>ID Type</label>
              <select name="idType" value={form.idType} onChange={handleChange}>
                <option>Aadhar</option>
                <option>PAN</option>
                <option>Driving License</option>
              </select>
            </div>
            <div className="form-group">
              <label>{form.idType} Number</label>
              <input type="text" name="idNumber" value={form.idNumber} onChange={handleChange} />
              {errors.idNumber && <span className="error">{errors.idNumber}</span>}
            </div>
            <div className="form-group">
              <label>Upload {form.idType}</label>
              <input type="file" name="idFile" onChange={handleChange} />
              {errors.idFile && <span className="error">{errors.idFile}</span>}
            </div>
          </div>
        </div>
        {/* Address Info */}
        <div className="section">
          <h3>Address Information</h3>
          <div className="fields-grid">
            <div className="form-group">
              <label>City</label>
              <input type="text" name="city" value={form.city} onChange={handleChange} />
              {errors.city && <span className="error">{errors.city}</span>}
            </div>
            <div className="form-group">
              <label>State</label>
              <input type="text" name="state" value={form.state} onChange={handleChange} />
              {errors.state && <span className="error">{errors.state}</span>}
            </div>
          </div>
        </div>
        {/* Bank Info */}
        <div className="section">
          <h3>Bank Details</h3>
          <div className="fields-grid">
            <div className="form-group">
              <label>Bank Account Number</label>
              <input type="text" name="bankAcc" value={form.bankAcc} onChange={handleChange} />
              {errors.bankAcc && <span className="error">{errors.bankAcc}</span>}
            </div>
            <div className="form-group">
              <label>Re-enter Bank Account Number</label>
              <input type="password" name="reBankAcc" value={form.reBankAcc} onChange={handleChange} />
              {errors.reBankAcc && <span className="error">{errors.reBankAcc}</span>}
            </div>
            <div className="form-group">
              <label>IFSC Code</label>
              <input type="text" name="ifsc" value={form.ifsc} onChange={handleChange} />
              {errors.ifsc && <span className="error">{errors.ifsc}</span>}
            </div>
            <div className="form-group">
              <label>Bank Name</label>
              <input type="text" name="bankName" value={form.bankName} onChange={handleChange} />
              {errors.bankName && <span className="error">{errors.bankName}</span>}
            </div>
            <div className="form-group">
              <label>Bank Branch Name</label>
              <input type="text" name="bankBranch" value={form.bankBranch} onChange={handleChange} />
              {errors.bankBranch && <span className="error">{errors.bankBranch}</span>}
            </div>
            <div className="form-group">
              <label>Upload Cancelled Cheque or Passbook Photo</label>
              <input type="file" name="checkPhoto" onChange={handleChange} />
              {errors.checkPhoto && <span className="error">{errors.checkPhoto}</span>}
            </div>
          </div>
        </div>
        {/* Terms and Submit */}
        <div className="section">
          <div className="checkbox-group">
            <input type="checkbox" name="acceptedTerms" checked={form.acceptedTerms} onChange={handleChange} />
            <label>I agree to the Terms and Conditions</label>
          </div>
          {errors.acceptedTerms && <span className="error">{errors.acceptedTerms}</span>}
          <button type="submit" disabled={loading}>
            {loading ? <div className="spinner" /> : 'Register'}
          </button>
        </div>
      </form>

      {/* Modal for Partner ID */}
      {showModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          background: 'rgba(0,0,0,0.4)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999
        }}>
          <div style={{
            background: '#fff',
            borderRadius: 8,
            padding: 32,
            minWidth: 320,
            boxShadow: '0 2px 16px rgba(0,0,0,0.2)',
            textAlign: 'center',
            maxWidth: 400
          }}>
            <h2>Registration Successful!</h2>
            <p style={{fontWeight: 'bold', color: '#333'}}>Your Partner ID:</p>
            <div style={{
              fontSize: 22,
              fontWeight: 'bold',
              color: '#1976d2',
              margin: '12px 0',
              wordBreak: 'break-all',
              background: '#f5f5f5',
              padding: '8px 12px',
              borderRadius: 4
            }}>{newPartnerId}</div>
            <p style={{color: '#b71c1c', fontWeight: 500}}>Please save this Partner ID. It will be required for login.</p>
            <div style={{marginTop: 24, display: 'flex', justifyContent: 'center', gap: 16}}>
              <button
                style={{padding: '8px 18px', background: '#1976d2', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer'}}
                onClick={() => { setShowModal(false); navigate('/partner/login'); }}
              >Return to Login</button>
              <button
                style={{padding: '8px 18px', background: '#aaa', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer'}}
                onClick={() => setShowModal(false)}
              >Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PartnerSignup;
